<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M13.013 3H2L10 12.46V19L14 21V12.46L14.9 11.405M22 3L17 8M17 3L22 8" stroke="#6782F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>